import { getIframeAndValidatePaymentApiRoute, payWithSavedCardApiRoute } from "@api-routes/eirStancerFacade";
import { getIframeAndValidatePaymentApiRoute as getElavonIframeAndValidatePaymentApiRoute } from "@api-routes/elavonFacade";
import { ElavonPaymentIframe } from "@common/PaymentIframe/elavon/ElavonPaymentIframe";
import { PaymentChoice } from "@common/PaymentChoice/PaymentChoice";
import { getSimplePaymentMethodCardList } from "@common/SimplePaymentMethodCardList";
import { useAuthPaymentIframe } from "@common/PaymentIframe/useAuthPaymentIframe";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { Box } from "@mui/material";

interface IParams {
    isNewPaymentProvider: boolean;
    successCallback(): void;
}

export const AuthPaymentIframe = (props: IParams) => {
    const { isNewPaymentProvider, successCallback } = props;

    const { paymentMethodListFetchState, paymentMethodList, getPaymentMethodList } = useAuthPaymentIframe({
        isNewPaymentProvider,
    });

    if (!isNewPaymentProvider) {
        return (
            <ElavonPaymentIframe
                iframePaymentApiRoute={getElavonIframeAndValidatePaymentApiRoute()}
                successCallback={successCallback}
                validatePaymentApiRoute={getElavonIframeAndValidatePaymentApiRoute()}
            />
        );
    }

    return (
        <Box paddingTop={4}>
            <HandleErrorAndLoading
                error={paymentMethodListFetchState.error}
                isLoading={paymentMethodListFetchState.isLoading}
                retryFetch={getPaymentMethodList}
            >
                {paymentMethodList && (
                    <PaymentChoice
                        iframePaymentApiRoute={getIframeAndValidatePaymentApiRoute()}
                        payWithSavedCardApiRoute={(cardId) => payWithSavedCardApiRoute(cardId)}
                        paymentMethodCardList={getSimplePaymentMethodCardList(paymentMethodList)}
                        successCallback={successCallback}
                        validatePaymentApiRoute={getIframeAndValidatePaymentApiRoute()}
                    />
                )}
            </HandleErrorAndLoading>
        </Box>
    );
};
